import { Check, ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const IMAGES = [
  "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1000&q=80",
  "https://images.unsplash.com/photo-1571896349842-33c89424de2d?auto=format&fit=crop&w=1000&q=80",
  "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=1000&q=80",
  "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1000&q=80",
];
const IDS = ["service-card-vacation", "service-card-hotel", "service-card-turnover", "service-card-management"];

export default function Services() {
  const { t } = useLang();

  return (
    <section id="services" className="bg-[#F3EFEA] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#C87A57]">{t.services.overline}</p>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight tracking-tight text-[#0E1B2A] text-balance">
            {t.services.title}
          </h2>
          <p className="mt-4 text-base sm:text-lg text-[#475569]">{t.services.sub}</p>
        </Reveal>

        <div data-testid="services-grid" className="mt-14 grid gap-7 sm:grid-cols-2">
          {t.services.cards.map((card, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <article
                data-testid={IDS[i]}
                className="group flex h-full flex-col overflow-hidden rounded-2xl border border-[#0E1B2A]/8 bg-white shadow-[0_10px_30px_rgba(14,27,42,0.04)] transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_-15px_rgba(14,27,42,0.18)]"
              >
                <div className="relative h-56 overflow-hidden sm:h-64">
                  <img
                    src={IMAGES[i]}
                    alt={card.t}
                    className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-108 group-hover:scale-110"
                  />
                  <span className="absolute left-5 top-5 rounded-full bg-[#0E1B2A]/80 px-3.5 py-1.5 font-display text-xs tracking-[0.2em] text-[#D4AF37] backdrop-blur-sm">
                    0{i + 1}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-7 sm:p-9">
                  <h3 className="font-serif text-xl sm:text-2xl font-semibold text-[#0E1B2A]">{card.t}</h3>
                  <p className="mt-2 text-sm sm:text-base text-[#475569]">{card.d}</p>
                  <ul className="mt-5 space-y-2.5">
                    {card.bullets.map((b, j) => (
                      <li key={j} className="flex items-start gap-2.5 text-sm text-[#334155]">
                        <Check size={16} className="mt-0.5 shrink-0 text-[#C87A57]" />
                        {b}
                      </li>
                    ))}
                  </ul>
                  <button
                    data-testid={`service-cta-${i + 1}`}
                    onClick={() => scrollToId("contact")}
                    className="mt-7 inline-flex w-fit items-center gap-1.5 text-sm font-semibold text-[#2C5E7A] transition-colors duration-300 hover:text-[#C87A57]"
                  >
                    {t.services.cta}
                    <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </button>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
